import React from 'react';

import { ServicePageLayoutComponent } from 'design/servicePageLayout';

import { LinkControlComponent } from 'design/linkControl';
import { TextComponent } from 'design/text/textComponents';
import { ORIGIN_SITE_URL } from 'utils/constants';
import { LogoComponent } from 'design/logo';
import { ThemeProviderComponent } from 'design/themeProvider';
import { SpinnerExtraLarge } from 'design/spinnerExtraLarge/spinnerExtraLargeComponents';
import { CenteredLayoutComponent } from 'design/centeredLayout/centeredLayoutComponents';
import { AccountControls } from 'containers/AccountControls';

export const ProdStackManagerAsyncFallback = () => {
  return (
    <ThemeProviderComponent mode="onLight">
      <ServicePageLayoutComponent
        theme="light"
        logo={
          <LinkControlComponent to={ORIGIN_SITE_URL}>
            <TextComponent color="primary" size="l">
              <LogoComponent />
            </TextComponent>
          </LinkControlComponent>
        }
        bodyContent={
          <CenteredLayoutComponent>
            <SpinnerExtraLarge />
          </CenteredLayoutComponent>
        }
        accountControls={
          <AccountControls redirectOnSignedOutTo={ORIGIN_SITE_URL} />
        }
      />
    </ThemeProviderComponent>
  );
};
